export default {
  path: '/ratio',
  meta: {
    title: '兑换积分中心',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio`),
}



// WEBPACK FOOTER //
// ./src/views/RatioCenter/router.js